import { createApp } from "vue";
import { vfmPlugin } from "vue-final-modal";
import VueA11yDialog from "vue-a11y-dialog";
import GlobalLangSelector from "./apps/GlobalLangSelector.vue";
import VueTheMask from 'vue-the-mask';
import InlineTemplateTestApp from "./apps/exp/InlineTemplateTestApp.vue";

function log(message, ...args) {
  if (import.meta.env.MODE === 'development') {
    console.log(`Toolkit: ${message}`, args)
  }
}

//based on the element's tagName, activate a vue element for that item
async function activateElement(el) {

  //a common set of plugins that all ADS Vue Apps will have access to
  function addCommonPlugins(app) {
    app.use(vfmPlugin)
    app.use(VueA11yDialog)
    app.use(VueTheMask)
  }


  if (!('appActivated' in el.dataset)) {

    log("Activating element:", el)
    el.dataset['appActivated'] = true;

    const tagName = el.tagName.toLowerCase()

    if (tagName === 'app-wrapper') {

      const AppWrapper = await import(`@scripts/apps/AppWrapper.vue`);
      const app = createApp(AppWrapper.default)
      addCommonPlugins(app)
      app.mount(el)
      return app


    } else if (tagName === 'exp-app-wrapper') {

      const ExpAppWrapper = await import(`@scripts/apps/exp/ExpAppWrapper.vue`);
      const app = createApp(ExpAppWrapper.default)
      addCommonPlugins(app)
      app.mount(el)
      return app


    } else if (tagName === 'ads-app') {

      const appName = el.getAttribute('data-app');
      const dataModel = el.getAttribute('data-display-model');
      if (appName) {
        try {
          const module = await import(`@scripts/apps/standalone/${appName}.vue`);
          const app = createApp(module.default);

          if (dataModel) {
            try {
              const parsedModel = JSON.parse(dataModel);
              app.provide("display-model", parsedModel);
            } catch (parseError) {
              console.error(`Failed to parse data-display-model for app: ${appName}`, parseError);
            }
          }

          addCommonPlugins(app)
          app.mount(el, { 'display-model': dataModel });
          return app

        } catch (error) {
          console.error(`Failed to load Vue component for app: ${appName}`, error)
        }
      } else {
        console.warn("ads-app provided no data-app to activate", el)
      }

    } else {
      console.error(`Unrecognized element ${tagName}, unable to activate.`)
    }

  } else {
    log("Element already activated, skipping:", el)
  }

  return null
}

async function activateAllChildrenElements(selector) {
  document.querySelectorAll(selector).forEach(async el => await activateElement(el))
}

function InitVue() {

  //activate all app-wrappers and ads-aps
  activateAllChildrenElements("app-wrapper, ads-app");


  // The GlobalLangSelector component does not require 'app-wrapper' as a root component
  // because it is being mounted directly to specific elements in the DOM that match
  // the '.global-lang-selector' selector
  const globalLanguageSelectors = document.querySelectorAll(".global-lang-selector");
  if (globalLanguageSelectors.length > 0) {
    globalLanguageSelectors.forEach(el => {
      const glsApp = createApp(GlobalLangSelector);
      glsApp.mount(el);
    });
  }

}


export { InitVue, activateElement, activateAllChildrenElements };